import { render, staticRenderFns } from "./RenderBlocks.vue?vue&type=template&id=acf1fb56&scoped=true&"
import script from "./RenderBlocks.vue?vue&type=script&lang=js&"
export * from "./RenderBlocks.vue?vue&type=script&lang=js&"
import style0 from "./RenderBlocks.vue?vue&type=style&index=0&id=acf1fb56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acf1fb56",
  null
  
)

export default component.exports